export const USER_LOGIN_FETCH_REQUEST = 'user-login-fetch-request';
export const USER_LOGIN_FETCH_SUCCESS = 'user-login-fetch-success';
export const USER_LOGIN_FETCH_FAILURE = 'user-login-fetch-failure';
export const USER_LOGIN_EMPTY = 'user-login-empty';